const isLayoutSwitchingDisabled = ({ blockItems = [], blockId }) => {
  const blockMeta = blockItems.find(({ id }) => id === blockId) || {};
  const { layoutSwitching } = blockMeta;

  return layoutSwitching === false;
};

export default isLayoutSwitchingDisabled;
